module.exports = "h3 {\n  float: right;\n  display: inline; }\n\nh1 {\n  display: inline; }\n\n.btn {\n  float: right;\n  margin: 10px;\n  background-color: #eeeeee;\n  color: black; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/apac-detail/list/list.component.scss
// module id = ./src/app/modules/apac-detail/list/list.component.scss
// module chunks = main